<template>
  <form autocomplete="false" v-on:submit.prevent>
    <vue-form-generator :schema="schema" :model="datas" :options="formOptions">
    </vue-form-generator>
  </form>
</template>

<script>
import { getHisto,addHisto,updateHisto,deleteHisto,getAllStatus } from '@/api/crm-api.js'

export default {
  components: {
    
  },
  props: {
    id: [String, Number],
    pec_id:[String, Number]
  },
  data () {
    return {
      datas: {},
      status: [],
      schema: {
        groups: [
          {
            legend: 'Statut',
            fields: [
              {
                type: 'select',
                model: 'status_id',
                selectOptions: { name:'nom', noneSelectedText: 'Non selectionné' },
                values: () => { return this.status },
                required: true
              },
              {
                type: 'textArea',
                model: 'note',
                placeholder: 'Note',
                rows: 15
              },
              {
                type: 'submit',
                buttonText: 'Ajouter',
                onSubmit: this.add,
                styleClasses:'col-auto p-0 float-right',
                validateBeforeSubmit: true,
                visible (modele) {
                    return modele.id == null;
                }
              },
              {
                type: 'submit',
                buttonText: 'Sauver',
                validateBeforeSubmit: true,
                onSubmit: this.update,
                styleClasses:'col-auto p-0 float-right',
                visible (modele) {
                    return modele != null && modele.id != null;
                }
              },
              {
                type: 'submit',
                buttonText: 'Supprimer',
                validateBeforeSubmit: false,
                onSubmit: this.delete,
                styleClasses:'col-auto float-left p-0',
                visible (modele) {
                    return modele != null && modele.id != null;
                }
              },
            ]
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      }
    }
  },
  methods: {
    refresh() {
      if(this.id != null) {
        getHisto(this.id)
        .then((response) => {
          this.datas = response.data
        })
        .catch((error) => {
          this.$store.commit('addMessage',{text:'Erreur lors du chargement de l\'historique des prises en charges: <br>'+error.toString(), status:'danger'})
        })
      } else {
        this.datas = {}
      }
    },
    add (rowData) {
      addHisto({pec_id:this.pec_id,status_id: rowData.status_id,note:rowData.note})
        .then((response) => {
          this.$emit('onNewAdded',response.data)
          this.$store.commit('addMessage',{text:'Le nouveau statut à bien été ajouté', status:'success'})
          this.refresh()
        })
        .catch((error) => {
          this.$store.commit('addMessage',{text:'Une erreur s\'est produite: <br>'+error.toString(), status:'danger'})
        })
    },
    update (rowData) {
      updateHisto({id:this.id,pec_id:this.pec_id,status_id: rowData.status_id,note:rowData.note})
        .then((response) => {
          this.$emit('onUpdate',response.data)
          this.$store.commit('addMessage',{text:'La modification à bien été effectuée', status:'success'})
        })
        .catch((error) => {
          this.$store.commit('addMessage',{text:'Une erreur s\'est produite: <br>'+error.toString(), status:'danger'})
        })
    },
    delete () {
      if(confirm('Etes vous sur de vouloir supprimer ce statut ?')) {
        deleteHisto(this.id,this.$store.state.User)
          .then(() => {
            this.$emit('onDelete')
            this.$store.commit('addMessage',{text:'La suppression à bien été effectuée', status:'success'})
          })
          .catch((error) => {
            this.$store.commit('addMessage',{text:'Une erreur s\'est produite: <br>'+error.toString(), status:'danger'})
          })
      }
    }
  },
  computed: {
  },
  watch: {
    id: {
      immediate: true,
      handler: function () {
        this.refresh()
      }
    },
    pec_id: {
      immediate: true,
      handler: function () {
        this.refresh()
      }
    }
  },
  mounted () {
    getAllStatus()
    .then((response) => {
      this.status = response.data.records
    })
    .catch((error) => {
      this.$store.commit('addMessage',{text:'Erreur lors du chargement des statut: <br>'+error.toString(), status:'danger'})
    })  
  }
}
</script>
